import { CalendarDaysIcon } from '@heroicons/react/20/solid'
import initials from 'initials'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { classNames, colorByString } from '../../helpers'
import { isSampleSpace } from '../../helpers/sample-data'
import SampleBadge from '../sample-data/sample-badge'
import Badge from '../tailwind/Badge'

const COLOR_MAP = {
  grey: 'gray',
  gray: 'gray',
  green: 'green',
  orange: 'yellow',
  red: 'red',
  yellow: 'yellow'
}

const CONTEXT_LABELS = {
  SELECT: 'Select',
  ATTRACT: 'Attract',
  TALENTPOOL: 'Talentpool'
}

const SpaceHeader = ({ space }) => {
  const { name, identification, assessment_status, createdAt, context } = space
  const { t } = useTranslation()

  const statusLabel = assessment_status?.status?.label
    ? t(assessment_status.status.label, {
        progress: assessment_status.status.progress
      })
    : null
  const statusColor = COLOR_MAP[assessment_status?.status?.color] || 'gray'
  const contextLabel = CONTEXT_LABELS[context]

  const formattedDate = createdAt
    ? new Date(createdAt).toLocaleDateString('de-DE', {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
      })
    : null

  const avatarColor = colorByString(name || identification || '')

  return (
    <div className='flex items-center space-x-4'>
      <div className='h-14 w-14 flex-shrink-0'>
        <span
          className={classNames(
            'inline-flex h-14 w-14 items-center justify-center rounded-full',
            avatarColor.backgroundColor
          )}
        >
          <span
            className={classNames(
              'text-2xl font-medium leading-none',
              avatarColor.text
            )}
          >
            {initials(space.initials)}
          </span>
        </span>
      </div>
      <div>
        <h1 className='text-2xl font-bold text-gray-900'>
          {name || identification}
        </h1>
        <div className='mt-1.5 flex items-center gap-x-2'>
          {isSampleSpace(space) && <SampleBadge kind='talent' />}
          {statusLabel && (
            <Badge text={statusLabel} color={statusColor} type='basic' />
          )}
          {contextLabel && (
            <>
              <span className='text-gray-300'>·</span>
              <span className='text-xs text-gray-500'>{contextLabel}</span>
            </>
          )}
          {formattedDate && (
            <>
              <span className='text-gray-300'>·</span>
              <span className='inline-flex items-center gap-x-1 text-xs text-gray-500'>
                <CalendarDaysIcon className='size-3.5 text-gray-400' />
                {formattedDate}
              </span>
            </>
          )}
        </div>
      </div>
    </div>
  )
}

SpaceHeader.propTypes = {
  space: PropTypes.object.isRequired
}

export default SpaceHeader
